export const estTaxPopup = () => {
  var timer
    $('.est-tax-question').mouseenter(function(){
        clearTimeout(timer);
        $('.est-tax-popup').show();
    });
    $('.est-tax-question').mouseout(function(){
      timer = setTimeout(function() {
        $('.est-tax-popup').hide();
      }, 2000);
    });
    $('.est-tax-close').click(function(){
        $('.est-tax-popup').hide();
    })
    $('.est-tax-question').click(function(){
        $('.est-tax-popup').show();
    });
};
